import React from "react";
import rectanglefifteen from "../assets/images/Rectangle 15.png"
import rectangletwo from "../assets/images/Rectangle 15 (1).png"
import rectanglethree from "../assets/images/Rectangle 15 (2).png"



const TestimonialSection = () => {
  return (
    <div className="relative bg-no-repeat md:bg-[url('https://cdn.blackincae.com/nsl-background-image-l-otto.png')] md:bg-[calc(100%+10px)_center] bottom-9">
      <div className="mx-auto main-container">
        <p className="pt-16 text-[#B91111] font-bold md:text-[36px] text-[30px] text-center mx-auto max-w-2xl bold-font px-3">
          I also wanted to make sure you feel your absolute best in every area
          of your life.
        </p>
        <p className="mt-4 text-[#204058] font-bold text-[28px] text-center mx-auto max-w-2xl italic bold-font">
          Because let’s be honest…
        </p>
        <p className="mt-8 text-[#282828] font-normal text-[20px] text-center mx-auto max-w-2xl md:px-0 px-2">
          Clearing up trapped mucus in your airways isn’t the
          <span className="font-bold"> ONLY </span> thing you want, right?
        </p>
        <div className="flex items-center justify-center">
          <div className="space-y-8 hidden md:block">
            <div className="flex items-center justify-start mt-8 ml-[100px]">
              <div className="flex-shrink-0 relative z-10">
                <img
                  src={rectanglefifteen}
                  alt="Description"
                  className="w-[125px] h-[125px] rounded-full"
                />
              </div>
              <div
                className="bg-[#EFF6FF] border-2 border-white rounded-full flex items-center pl-[80px] pr-10 py-6 -ml-16"
                style={{ boxShadow: "0px 1px 4px 0px rgba(0, 0, 0, 0.15)" }}
              >
                <p className="text-[#282828] font-bold text-[21px]">
                  You want to feel energized and vibrant…
                </p>
              </div>
            </div>
            <div className="flex items-center justify-start mt-6 mr-[70px]">
              <div className="flex-shrink-0 relative z-10">
                <img
                  src={rectangletwo}
                  alt="Description"
                  className="w-[125px] h-[125px] rounded-full"
                />
              </div>
              <div
                className="bg-[#EFF6FF] border-2 border-white rounded-full flex items-center pl-[80px] pr-10 py-2 -ml-16"
                style={{ boxShadow: "0px 1px 4px 0px rgba(0, 0, 0, 0.15)" }}
              >
                <p className="text-[#282828] font-bold text-[21px]">
                  You want to feel strong and confident - your <br />
                  body fortified with potent, natural immunity…
                </p>
              </div>
            </div>
            <div className="flex items-center justify-start mt-6 ml-[100px]">
              <div className="flex-shrink-0 relative z-10">
                <img
                  src={rectanglethree}
                  alt="Description"
                  className="w-[125px] h-[125px] rounded-full"
                />
              </div>
              <div
                className="bg-[#EFF6FF] border-2 border-white rounded-full flex items-center pl-[80px] pr-10 py-2 -ml-16"
                style={{ boxShadow: "0px 1px 4px 0px rgba(0, 0, 0, 0.15)" }}
              >
                <p className="text-[#282828] font-bold text-[21px]">
                  You want to wake up each morning with <br />
                  clear-eyed, youthful vitality…
                </p>
              </div>
            </div>
          </div>
          <div className="space-y-8 block md:hidden mt-12">
            <div className="mx-12 pt-12">
              <div
                className="mx-auto p-8 lg:p-10 rounded-3xl border-2 border-white max-w-lg text-center bg-[#EFF6FF]"
                style={{ boxShadow: "0px 1px 4px 0px rgba(0, 0, 0, 0.15)" }}
              >
                <img
                  src={rectanglefifteen}
                  alt="Cookies"
                  className="w-32 h-32 mx-auto rounded-full -mt-24"
                />
                <h2 className="text-[#282828] font-bold text-[21px] mt-4">
                  You want to feel energized and vibrant…
                </h2>
              </div>
            </div>
            <div className="mx-12 pt-12">
              <div
                className="mx-auto p-8 lg:p-10 rounded-3xl border-2 border-white max-w-lg text-center bg-[#EFF6FF]"
                style={{ boxShadow: "0px 1px 4px 0px rgba(0, 0, 0, 0.15)" }}
              >
                <img
                  src={rectangletwo}
                  alt="Cookies"
                  className="w-32 h-32 mx-auto rounded-full -mt-24"
                />
                <h2 className="text-[#282828] font-bold text-[21px] mt-4">
                  You want to feel strong and confident - your body fortified
                  with potent, natural immunity…
                </h2>
              </div>
            </div>
            <div className="mx-12 pt-12">
              <div
                className="mx-auto p-8 lg:p-10 rounded-3xl border-2 border-white max-w-lg text-center bg-[#EFF6FF]"
                style={{ boxShadow: "0px 1px 4px 0px rgba(0, 0, 0, 0.15)" }}
              >
                <img
                  src={rectanglethree}
                  alt="Cookies"
                  className="w-32 h-32 mx-auto rounded-full -mt-24"
                />
                <h2 className="text-[#282828] font-bold text-[21px] mt-4">
                  You want to wake up each morning with clear-eyed, youthful
                  vitality…
                </h2>
              </div>
            </div>
          </div>
        </div>

        <p className="mt-8 text-[#282828] font-normal text-[20px] text-start mx-auto max-w-2xl px-2">
          Ready and eager to take on the day without anything holding you back.
        </p>

        <p className="mt-6 text-[#282828] font-normal text-[20px] text-start mx-auto max-w-2xl px-2">
          That’s exactly why I worked so hard to develop something that will
          supercharge the way you feel every day.
        </p>

        <p className="mt-6 text-[#282828] font-normal text-[20px] text-start mx-auto max-w-2xl px-2 md:pb-[150px] pb-[0px]">
          It’s something that will take you from feeling "just OK" - to feeling
          unstoppable.
        </p>
      </div>
    </div>
  );
};

export default TestimonialSection;
